// Use this theme only when a Tailwind class (e.g., .text-gray-600) cannot be applied.
//
// This typically occurs when converting from CSS-in-JS to pure Tailwind is not feasible.

const raydialTheme = {
  gray100: '#F3F3F3',
  gray400: '#A4A4A4',
  gray600: '#6F6F6F',
};

export default raydialTheme;
